import request from "@/utils/request";

let baseApi = '/dj-api'

const common = {
  // 获取配置中心配置信息
  getConfigCenter() {
    const url = `${baseApi}/config/getConfig`
    return request.post(url)
  }
}

const themezone = {
  // 主题专区配置信息
  getConfig() {
    const url = `${baseApi}/themeArea/config`
    return request.post(url)
  },
  // 主题专区商品列表
  getItems(data) {
    const url = `${baseApi}/themeArea/getItems`
    return request.post(url, data)
  }
}

export default {
  common,
  themezone
}